import { defineComponent as _defineComponent } from 'vue'
import { Select } from 'ant-design-vue'
import { onMounted, ref } from 'vue'
import { getFacultyList } from '@/api/web'


export default /*#__PURE__*/_defineComponent({
  __name: 'SelectFaculty',
  emits: ['input'],
  setup(__props, { emit }) {

const options = ref<{ label: string; value: string }[]>()

const loading = ref(false)
onMounted(() => {
  loading.value = true
  getFacultyList({})
    .then((response) => {
      options.value = response.data.map((i) => ({
        label: i.name,
        value: i.name,
      }))
    })
    .finally(() => {
      loading.value = false
    })
})


function onChange(val: string) {
  emit('input', val)
}

return { __sfc: true,options, loading, emit, onChange, Select }
}

})